import { render, staticRenderFns } from "./Marking.vue?vue&type=template&id=dee8f47e&scoped=true"
import script from "./Marking.vue?vue&type=script&lang=js"
export * from "./Marking.vue?vue&type=script&lang=js"
import style0 from "./Marking.vue?vue&type=style&index=0&id=dee8f47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee8f47e",
  null
  
)

export default component.exports